import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isNavOpen: false,
    next: null,
    prev: null
  },
  mutations: {
    toggleNav(state) {
      state.isNavOpen = !state.isNavOpen;
    },
    updateNext(state, next) {
      state.next = next;
    },
    updatePrev(state, prev) {
      state.prev = prev;
    }
  },
  actions: {}
});
